function subscribeEvent(eventName, listener) {
  document.addEventListener(eventName, listener);
}

function unsubscribeEvent(eventName, listener) {
  document.removeEventListener(eventName, listener);
}

function publishEvent(eventName, data) {
  const event = new CustomEvent(eventName, { detail: data });
  document.dispatchEvent(event);
}

export { publishEvent, subscribeEvent, unsubscribeEvent};